import styled from 'styled-components';

export const Wrapper = styled.div`
  max-height: 240px;
  overflow: auto;
`;
